<script>
import DashHeader from "./DashHeader"
import { mapGetters, mapMutations } from "vuex"
import Sidebar from "@/components/Sidebar"
import LocationFooterNav from "@/components/layout/LocationFooterNav"
import WeatherLocationModal from "@/components/location/WeatherLocationModal.vue"

export default {
    name: "Dash",
    components: {
        Sidebar,
        DashHeader,
        LocationFooterNav,
        WeatherLocationModal,
    },
    data() {
        return {
            search: "",
            menu2: null,
            menu: null,
            isOnMobile: false,
            classes: {},
        }
    },
    computed: {
        ...mapGetters("sidebar", {
            sidebarMenu: "sidebarMenu",
            isSidebarVisible: "isSidebarVisible",
            isSidebarLoading: "isSidebarLoading",
            selectedCompany: "company",
        }),
        ...mapGetters("siteInfo", {
            maintenanceStatus: "maintenanceStatus",
            showMaintenanceNotification: "showMaintenanceNotification",
        }),
        isImpersonating() {
            return this.$store.getters["auth/impersonating"]
        },
        isLocationView() {
            return !!this.locationId
        },
        companyId() {
            return this.$route.params.companyId
        },
        locationId() {
            return this.$route.params.locationId
        },
        locationGroupId() {
            return this.$route.params.locationGroupId
        },
        sidebarMenuWidth() {
            if (this.isOnMobile) {
                return "100%"
            }

            return "360px"
        },
        isSidebarCollapsed: {
            get() {
                return !this.isSidebarVisible
            },
            set(value) {
                return this.setSidebarVisibility(!value)
            },
        },
    },
    watch: {},
    created() {},
    methods: {
        ...mapMutations("appLayoutModule", ["setContentRef"]),
        dismissNotification() {
            this.$store.dispatch("siteInfo/dismissMaintenanceNotification")
        },
    },
    mounted() {
        this.setContentRef(this.$refs.contentDiv)
    },
}
</script>

<template>
    <div id="wrapper">
        <Sidebar />

        <div
            id="content"
            class="main-content"
            :class="{ 'has-location-footer': locationId || locationGroupId }"
            style="overflow: hidden"
            ref="contentDiv"
        >
            <template v-if="!isSidebarLoading">
                <div class="notifications-wrapper">
                    <div class="global-notification">
                        <div v-if="showMaintenanceNotification" class="notification">
                            {{ maintenanceStatus.message }}

                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click.prevent="dismissNotification"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                </div>

                <dash-header></dash-header>

                <div class="inner-content" style="overflow-x: hidden; overflow-y: auto">
                    <router-view></router-view>
                </div>

                <template v-if="locationId || locationGroupId">
                    <LocationFooterNav />
                </template>
            </template>
        </div>

        <WeatherLocationModal />
    </div>
</template>

<style scoped>
.main-content {
    padding-bottom: 60px !important;
}

@media (max-width: 768px) {
    .main-content {
        padding-bottom: 40px !important;
    }

    .has-location-footer {
        padding-bottom: 100px !important;
    }
}
</style>
